import { render, staticRenderFns } from "./editHolidayType.vue?vue&type=template&id=a8797c3a&"
import script from "./editHolidayType.vue?vue&type=script&lang=js&"
export * from "./editHolidayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8797c3a')) {
      api.createRecord('a8797c3a', component.options)
    } else {
      api.reload('a8797c3a', component.options)
    }
    module.hot.accept("./editHolidayType.vue?vue&type=template&id=a8797c3a&", function () {
      api.rerender('a8797c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveType/components/editHolidayType.vue"
export default component.exports